import { render } from "./Drone.vue?vue&type=template&id=64d24022"
import script from "./Drone.vue?vue&type=script&lang=js"
export * from "./Drone.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__